import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import { Link } from "react-router-dom";

interface ContentItem {
  _id: string;
  title: string;
  description?: string;
  contentType: string;
  imageUrl?: string;
  createdAt: string;
}

interface ContentSectionProps {
  title: string;
  icon: string;
  items: ContentItem[];
  linkPath: string;
  bgColor?: string;
  textColor?: string;
}

const ContentSection: React.FC<ContentSectionProps> = ({ 
  title, 
  icon, 
  items, 
  linkPath,
  bgColor = "#f8f9fa",
  textColor = "#333"
}) => {
  if (items.length === 0) {
    return null;
  }

  const formatDate = (dateString: string) => {
    return new Date(dateString).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    });
  };

  return (
    <section className="py-5" style={{ backgroundColor: bgColor }}>
      <Container>
        <div className="text-center mb-4">
          <h2 className="mb-3" style={{ color: textColor }}>
            <i className={`bi ${icon} me-2`}></i>
            {title}
          </h2>
          <div 
            className="mx-auto mb-4" 
            style={{ 
              width: "80px", 
              height: "3px", 
              background: "linear-gradient(45deg, #810081, #FFD600)", 
              borderRadius: "2px" 
            }}
          ></div>
        </div>
        
        <Row className="g-4">
          {items.map((item) => (
            <Col key={item._id} md={6} lg={4}>
              <Card className="h-100 shadow-sm border-0">
                {item.imageUrl && (
                  <Card.Img 
                    variant="top" 
                    src={item.imageUrl} 
                    style={{ height: "180px", objectFit: "cover" }}
                  />
                )}
                <Card.Body>
                  <Card.Title className="h5">{item.title}</Card.Title>
                  {item.description && (
                    <Card.Text className="text-muted">
                      {item.description.length > 100 
                        ? `${item.description.substring(0, 100)}...` 
                        : item.description}
                    </Card.Text>
                  )}
                  <div className="d-flex justify-content-between align-items-center mt-3">
                    <small className="text-muted">
                      <i className="bi bi-calendar me-1"></i>
                      {formatDate(item.createdAt)}
                    </small>
                    <Link 
                      to={`${linkPath}/${item._id}`} 
                      className="btn btn-sm"
                      style={{ backgroundColor: "#FFD600", color: "#810081", border: "none" }}
                    >
                      Read More
                    </Link>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
        
        <div className="text-center mt-4">
          <Link 
            to={linkPath} 
            className="btn px-4 py-2"
            style={{ backgroundColor: "#810081", color: "white", border: "none" }}
          >
            View All <i className="bi bi-arrow-right ms-2"></i>
          </Link>
        </div>
      </Container>
    </section>
  );
};

export default ContentSection;